module.exports = __webpack_public_path__ + "img/hbg.992c3f8f.png";